/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef } from "react";
import styled from "styled-components";
import { CloudUpload } from "@material-ui/icons";
import { Notify } from "../../../../../../UIcomponent/NotificationManager";
import DefaultAvatar from "../../../../../../Assets/images/AvatarDefault.jpg";
import ProfileReq from "../../../../../../Utility/Requester/ProfileReq";
import CropDialog from "./CropDialog";
import Urls from "../../../../../../Utility/Urls";
import { useCallback } from "react";

const UploadImage = (props) => {
  const { defaultImage } = props;
  const inputRef = useRef(null);
  const [upImg, setUpImg] = React.useState();
  const [isFetching, setIsFetching] = React.useState(false);
  const [openCropper, setCropperOpen] = React.useState(false);
  const [finalImage, setFinalImage] = React.useState(
    defaultImage ? `${Urls.avatar()}${defaultImage}` : DefaultAvatar
  );

  const onSelectFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        setUpImg(reader.result);
        setCropperOpen(true);
        inputRef.current.value = null;
      });
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const onSelectCrop = useCallback((e) => {
    if (e) {
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        setUpImg(reader.result);
        setFinalImage(reader.result);
      });
      reader.readAsDataURL(e);
      uploadImage(e);
    }
  }, []);

  const uploadImage = (e) => {
    setIsFetching(true);
    const data = new FormData();
    data.append("avatar", e);
    ProfileReq.UpdateAvatar(data)
      .then((res) => {
        Notify("success", "تصویر با موفقیت بروز رسانی شد.", 3000);
        setIsFetching(false);
      })
      .catch((err) => {
        console.log(err);
        setIsFetching(false);
      });
  };

  return (
    <>
      <ImageWrapper>
        <input
          className="input"
          ref={inputRef}
          type="file"
          accept="image/*"
          onChange={onSelectFile}
        />
        <div
          className="inner-container"
          onClick={() => inputRef.current.click()}
        >
          <div className="upload-overlay">
            <CloudUpload />
          </div>
          <img src={finalImage} alt="" width="150" height="150" />
        </div>
        <div className="ctrl-section">
          <p>حجم تصویر پروفایل شما باید کمتر از 2 مگابایت باشد.</p>
          <div
            className="upload-button"
            onClick={() => {
              if (isFetching) {
                return undefined;
              }
              return inputRef.current.click();
            }}
          >
            {isFetching ? "در حال بارگزاری" : "انتخاب تصویر"}
          </div>
        </div>
      </ImageWrapper>
      <CropDialog
        isOpen={openCropper}
        takeNewImage={onSelectCrop}
        closeCropper={() => {
          setCropperOpen(false);
        }}
        upImg={upImg}
      />
    </>
  );
};

const ImageWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  input {
    display: none;
  }
  .inner-container {
    box-shadow: 1px 1px 10px -5px #cdcdcd;
    margin: 25px 0;
    display: inline-block;
    position: relative;
    overflow: hidden;
    border: 4px solid #ffffff;
    border-radius: 100%;
    width: 120px;
    height: 120px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 120px;
      height: 120px;
    }
    .upload-overlay {
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      border-radius: 100%;
      background-color: rgba(255, 255, 255, 0.7);
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      opacity: 0;
      cursor: pointer;
      transition: 0.5s opacity ease;
      z-index: 1;
    }
    &:hover {
      .upload-overlay {
        opacity: 1;
      }
    }
    .remove-button {
      z-index: 2;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #ffffff;
      border-radius: 100%;
      position: absolute;
      padding: 2px;
      left: 6px;
      bottom: 6px;
    }
    img {
      border-radius: 100%;
    }
  }
  .ctrl-section {
    margin: 0 10px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    > div {
      cursor: pointer;
      border-radius: 250px;
      padding: 10px 15px;
      margin: 0 5px;
      font-size: 0.8rem;
      &.upload-button {
        border: 1px solid #333333;
        color: #333333;
      }
    }
  }
`;

export default UploadImage;
